import styled from 'styled-components';

export const SelectorPickerContainer = styled.div`
    .fixedValues {
        display: grid;
        grid-column-gap: 34px;
        grid-row-gap: 10px;
        grid-template-columns: repeat(4, 90px);

        @media screen and (max-width: 360px) {
            grid-template-columns: repeat(2, 100px);
        }
        @media screen and (min-width: 360px) and (max-width: 420px) {
            grid-template-columns: repeat(3, 70px);
        }
        @media screen and (min-width: 420px) and (max-width: 500px) {
            grid-template-columns: repeat(3, 90px);
        }
        @media screen and (min-width: 500px) and (max-width: 540px) {
            grid-template-columns: repeat(4, 80px);
        }
    }

    .freeValues {
        margin: 0 0 20px;
        display: flex;
        align-items: center;
        height: 45px;
        max-width: 462px;

        label {
            display: flex;
            align-items: center;
            height: 100%;
            margin-top: 0;
            background-color: ${props => props.theme.primary};
            color: ${props => props.theme.white};
            padding: 10px;
            border-radius: 5px 0 0 5px;
        }

        .symbol {
            display: flex;
            align-items: center;
            height: 100%;
            padding: 12px;
            background-color: ${props => props.theme.white};
            color: ${props => props.theme.lightGrey};
            border: 1px solid ${props => props.theme.lightGrey};
            border-left: none;
            font-size: 18px;
            border-radius: 0 5px 5px 0;
        }
    }

    .button-ebon {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: ${props => props.theme.white};
        height: 47px;
        width: 100%;
        border: 1px solid ${props => props.theme.whiteGrey};
        cursor: pointer;

        &.selected {
            background-color: ${props => props.theme.primary};

            & > p {
                color: ${props => props.theme.white};
            }
        }

        & > p {
            font-size: 16px;

            &.soldOut {
                font-size: 9px;
            }

            & + p {
                margin-top: 0;
            }
        }

        &:disabled,
        &[disabled] {
            p.value {
                text-decoration: line-through;
            }
        }
    }

    .error {
        font-size: 12px;
        font-style: italic;
        color: ${props => props.theme.error};
        margin: 0 0 20px;
    }

    .no-availability {
        width: 100%;
        text-align: center;
    }

    @media (max-width: ${props => props.theme.mobile}) {
        .no-availability {
            margin: 0 0 10px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/ebonselector/EbonSelectorPickerComponentStyle.js